/**
 * @generated SignedSource<<944ebd92cfaa89b537b3964c6de2dcf9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrganizationRole = "admin" | "member" | "owner" | "%future added value";
export type ProductRole = "instructor" | "manager" | "member" | "%future added value";
export type MemberProfileContextQuery$variables = {
  canViewNotes: boolean;
  id: string;
  isSelfViewing: boolean;
  organizationId: string;
  productId: string;
};
export type MemberProfileContextQuery$data = {
  readonly user: {
    readonly __typename: "User";
    readonly calendarConnection: {
      readonly id: string;
    } | null;
    readonly id: string;
    readonly organizationMembership: {
      readonly id: string;
      readonly organization: {
        readonly viewerMembershipPlan: {
          readonly id: string;
          readonly isFreeMembership: boolean | null;
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"CancelMembershipPlanButtonFragment">;
        };
      };
      readonly role: OrganizationRole;
      readonly " $fragmentSpreads": FragmentRefs<"ProfileSettingsCertificateSectionFragment" | "ProfileSettingsDetailsTabNotesFragment" | "useMemberGroupTagsList_OrganizationMembershipFragment">;
    } | null;
    readonly productMembership: {
      readonly id: string;
      readonly role: ProductRole;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProfileSettingsAccountTabFragment" | "ProfileSettingsProfileTabFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type MemberProfileContextQuery = {
  response: MemberProfileContextQuery$data;
  variables: MemberProfileContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canViewNotes"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSelfViewing"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFreeMembership",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "productId",
      "variableName": "productId"
    }
  ],
  "concreteType": "ProductMembership",
  "kind": "LinkedField",
  "name": "productMembership",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarConnection",
  "kind": "LinkedField",
  "name": "calendarConnection",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webFormQuestionId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedOptions",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v20 = {
  "kind": "Literal",
  "name": "status",
  "value": "visible"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v23 = {
  "kind": "Literal",
  "name": "isDefault",
  "value": false
},
v24 = {
  "kind": "Literal",
  "name": "isPrivate",
  "value": false
},
v25 = [
  (v16/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaUrl",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v29 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Badge",
    "kind": "LinkedField",
    "name": "badge",
    "plural": false,
    "selections": [
      (v27/*: any*/),
      (v28/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "icon",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emoji",
        "storageKey": null
      },
      (v26/*: any*/),
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  (v6/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTest",
  "storageKey": null
},
v33 = [
  {
    "kind": "Literal",
    "name": "groupKinds",
    "value": [
      "custom"
    ]
  }
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MemberProfileContextQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "args": (v8/*: any*/),
                "kind": "FragmentSpread",
                "name": "ProfileSettingsProfileTabFragment"
              },
              {
                "condition": "isSelfViewing",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v8/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "ProfileSettingsAccountTabFragment"
                  }
                ]
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "organizationMembership",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v9/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProfileSettingsCertificateSectionFragment"
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "canViewNotes",
                        "variableName": "canViewNotes"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ProfileSettingsDetailsTabNotesFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useMemberGroupTagsList_OrganizationMembershipFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "viewerMembershipPlan",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "CancelMembershipPlanButtonFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MemberProfileContextQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "website",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cover",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "organizationMembership",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileValueNodeConnection",
                    "kind": "LinkedField",
                    "name": "profileValues",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileValueNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileValue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "profileField",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormAnswer",
                                "kind": "LinkedField",
                                "name": "webFormAnswer",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  (v17/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebForm",
                        "kind": "LinkedField",
                        "name": "profileWebForm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebFormRevision",
                            "kind": "LinkedField",
                            "name": "currentRevision",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "webFormId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormQuestionNodeConnection",
                                "kind": "LinkedField",
                                "name": "questions",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormQuestionNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WebFormQuestion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v19/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "richEditorBody",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "ordering",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRequired",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WebFormQuestionOption",
                                            "kind": "LinkedField",
                                            "name": "options",
                                            "plural": true,
                                            "selections": [
                                              (v6/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "label",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "defaultFields",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "isDefault",
                            "value": true
                          },
                          (v20/*: any*/)
                        ],
                        "concreteType": "ProfileFieldNodeConnection",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileFieldNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "profileFields(isDefault:true,status:\"visible\")"
                      },
                      {
                        "alias": "customFields",
                        "args": [
                          (v23/*: any*/),
                          (v20/*: any*/)
                        ],
                        "concreteType": "ProfileFieldNodeConnection",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileFieldNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "profileFields(isDefault:false,status:\"visible\")"
                      },
                      (v6/*: any*/),
                      {
                        "alias": "publicCustomFields",
                        "args": [
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v20/*: any*/)
                        ],
                        "concreteType": "ProfileFieldNodeConnection",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileFieldNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormQuestion",
                                    "kind": "LinkedField",
                                    "name": "webFormQuestion",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "profileFields(isDefault:false,isPrivate:false,status:\"visible\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "viewerMembershipPlan",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "frequency",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CancelMembershipPlan",
                            "kind": "LinkedField",
                            "name": "viewerCanCancelMembershipPlan",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "displayProfileValues",
                    "args": [
                      (v24/*: any*/)
                    ],
                    "concreteType": "ProfileValueNodeConnection",
                    "kind": "LinkedField",
                    "name": "profileValues",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileValueNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileValue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profileFieldId",
                                "storageKey": null
                              },
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "profileValues(isPrivate:false)"
                  },
                  (v6/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserCertificateNodeConnection",
                    "kind": "LinkedField",
                    "name": "userCertificates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserCertificateNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserCertificate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": (v29/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Organization",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": (v29/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "canViewNotes",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserNoteNodeConnection",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserNoteNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "addedByUser",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v31/*: any*/),
                                      (v14/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__id",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "alias": null,
                    "args": (v33/*: any*/),
                    "concreteType": "MemberGroupMembershipNodeConnection",
                    "kind": "LinkedField",
                    "name": "groupMemberships",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroupMembershipNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroupMembership",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroup",
                                "kind": "LinkedField",
                                "name": "memberGroup",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "parentMemberGroupId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "visibility",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isSystem",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfoObjectType",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "groupMemberships(groupKinds:[\"custom\"])"
                  },
                  {
                    "alias": null,
                    "args": (v33/*: any*/),
                    "filters": [
                      "groupKinds"
                    ],
                    "handle": "connection",
                    "key": "useMemberGroupTagsList_OrganizationMembershipFragment_groupMemberships",
                    "kind": "LinkedHandle",
                    "name": "groupMemberships"
                  }
                ],
                "storageKey": null
              },
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "websiteUrl",
                "storageKey": null
              },
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "condition": "isSelfViewing",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canChangeEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasSocialAuth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "concreteType": "OrganizationMembership",
                    "kind": "LinkedField",
                    "name": "organizationMembership",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "member",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 2
                              }
                            ],
                            "concreteType": "OrganizationMembershipNodeConnection",
                            "kind": "LinkedField",
                            "name": "organizationMemberships",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrganizationMembershipNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrganizationMembership",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Organization",
                                        "kind": "LinkedField",
                                        "name": "organization",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "primaryDomain",
                                            "storageKey": null
                                          },
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "organizationMemberships(first:2)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stripeAccountId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "checkoutVersion",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stripePortalConfigId",
                            "storageKey": null
                          },
                          {
                            "alias": "plans",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "hideDrafts",
                                "value": true
                              },
                              {
                                "kind": "Literal",
                                "name": "type",
                                "value": "membership_plan"
                              }
                            ],
                            "concreteType": "ProductNodeConnection",
                            "kind": "LinkedField",
                            "name": "products",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/)
                            ],
                            "storageKey": "products(hideDrafts:true,type:\"membership_plan\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "viewerMembershipPlan",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ChangeMembershipPlan",
                                "kind": "LinkedField",
                                "name": "viewerCanChangeMembershipPlan",
                                "plural": false,
                                "selections": (v25/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stripeConnectedCustomerId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f4eea5d12a7173bb951fdeaedbac745",
    "id": null,
    "metadata": {},
    "name": "MemberProfileContextQuery",
    "operationKind": "query",
    "text": "query MemberProfileContextQuery(\n  $id: ID!\n  $productId: ID!\n  $organizationId: ID!\n  $isSelfViewing: Boolean!\n  $canViewNotes: Boolean!\n) {\n  user: node(id: $id) {\n    __typename\n    ... on User {\n      id\n      __typename\n      ...ProfileSettingsProfileTabFragment_4xMPKw\n      ...ProfileSettingsAccountTabFragment_4xMPKw @include(if: $isSelfViewing)\n      organizationMembership(organizationId: $organizationId) {\n        id\n        role\n        ...ProfileSettingsCertificateSectionFragment\n        ...ProfileSettingsDetailsTabNotesFragment_3TFJ0o\n        ...useMemberGroupTagsList_OrganizationMembershipFragment\n        organization {\n          viewerMembershipPlan {\n            id\n            name\n            isFreeMembership\n            ...CancelMembershipPlanButtonFragment\n          }\n          id\n        }\n      }\n      productMembership(productId: $productId) {\n        id\n        role\n      }\n      calendarConnection {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment CancelMembershipPlanButtonFragment on Product {\n  id\n  name\n  isFreeMembership\n  pricing {\n    frequency\n    id\n  }\n  viewerCanCancelMembershipPlan {\n    value\n    message\n  }\n}\n\nfragment CertificateCardFragment on UserCertificate {\n  id\n  mediaUrl\n  product {\n    name\n    badge {\n      ...BadgeFragment\n      id\n    }\n    id\n  }\n  organization {\n    name\n    badge {\n      ...BadgeFragment\n      id\n    }\n    id\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment MembershipPlanSelectButton_OrganizationFragment on Organization {\n  id\n  viewerMembershipPlan {\n    id\n    viewerCanChangeMembershipPlan {\n      value\n      message\n    }\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileAvatarWithDetailsFragment on User {\n  id\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment ProfileNameWithTagFragment on User {\n  fullName\n}\n\nfragment ProfileSettingsAccountTabEmailSectionFragment on User {\n  email\n  hasSocialAuth\n  canChangeEmail\n  isTest\n}\n\nfragment ProfileSettingsAccountTabFragment_4xMPKw on User {\n  email\n  canChangeEmail\n  hasSocialAuth\n  isTest\n  organizationMembership(organizationId: $organizationId) {\n    ...RemoveCommunityMemberButtonFragment\n    stripeConnectedCustomerId\n    organization {\n      stripeAccountId\n      checkoutVersion\n      stripePortalConfigId\n      plans: products(type: \"membership_plan\", hideDrafts: true) {\n        totalCount\n      }\n      ...MembershipPlanSelectButton_OrganizationFragment\n      id\n    }\n    id\n  }\n  ...ProfileSettingsAccountTabEmailSectionFragment\n}\n\nfragment ProfileSettingsCertificateSectionFragment on OrganizationMembership {\n  userCertificates {\n    edges {\n      node {\n        id\n        ...CertificateCardFragment\n      }\n    }\n  }\n}\n\nfragment ProfileSettingsCustomFieldsFragment_3fb12f on OrganizationMembership {\n  organization {\n    publicCustomFields: profileFields(status: visible, isPrivate: false, isDefault: false) {\n      edges {\n        node {\n          id\n          title\n          webFormQuestion {\n            type\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  displayProfileValues: profileValues(isPrivate: false) {\n    edges {\n      node {\n        id\n        profileFieldId\n        value\n      }\n    }\n  }\n}\n\nfragment ProfileSettingsCustomFormFieldsFragment on Organization {\n  customFields: profileFields(status: visible, isDefault: false) {\n    edges {\n      node {\n        id\n        title\n        isPrivate\n        webFormQuestionId\n      }\n    }\n  }\n  profileWebForm {\n    currentRevision {\n      questions {\n        edges {\n          node {\n            id\n            type\n            richEditorBody\n            options {\n              id\n              label\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ProfileSettingsDetailsTabNotesFragment_3TFJ0o on OrganizationMembership {\n  id\n  notes @include(if: $canViewNotes) {\n    totalCount\n    edges {\n      node {\n        id\n        ...UserNotesItemFragment\n      }\n    }\n  }\n}\n\nfragment ProfileSettingsProfileBannerFragment on User {\n  id\n  cover\n  ...ProfileAvatarFragment\n  ...ProfileNameWithTagFragment\n  isTest\n}\n\nfragment ProfileSettingsProfileFormFieldsFragment on Organization {\n  defaultFields: profileFields(status: visible, isDefault: true) {\n    edges {\n      node {\n        id\n        title\n        isPrivate\n      }\n    }\n  }\n}\n\nfragment ProfileSettingsProfileTabFragment_4xMPKw on User {\n  id\n  website\n  timezone\n  bio\n  lastName\n  firstName\n  avatar\n  cover\n  organizationMembership(organizationId: $organizationId) {\n    profileValues {\n      edges {\n        node {\n          id\n          profileField {\n            webFormQuestionId\n            id\n          }\n          value\n          selectedOptions\n          webFormAnswer {\n            body\n            selectedOptions\n            id\n          }\n        }\n      }\n    }\n    organization {\n      profileWebForm {\n        currentRevision {\n          id\n          webFormId\n          questions {\n            edges {\n              node {\n                id\n                type\n                richEditorBody\n                ordering\n                isRequired\n                options {\n                  id\n                  label\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n      ...ProfileSettingsProfileFormFieldsFragment\n      ...ProfileSettingsCustomFormFieldsFragment\n      id\n    }\n    ...ProfileSettingsCustomFieldsFragment_3fb12f\n    id\n  }\n  ...ProfileSettingsProfileBannerFragment\n  ...ProfileSettingsUserSectionFragment_4xMPKw\n  ...ProfileNameWithTagFragment\n}\n\nfragment ProfileSettingsUserSectionFragment_4xMPKw on User {\n  id\n  bio\n  websiteUrl\n  timezone\n  organizationMembership(organizationId: $organizationId) {\n    id\n    organization {\n      defaultFields: profileFields(status: visible, isDefault: true) {\n        edges {\n          node {\n            id\n            title\n            isPrivate\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment RemoveCommunityMemberButtonFragment on OrganizationMembership {\n  id\n  member {\n    id\n    organizationMemberships(first: 2) {\n      edges {\n        node {\n          id\n          organization {\n            slug\n            primaryDomain\n            id\n          }\n        }\n      }\n    }\n  }\n  organization {\n    id\n    slug\n  }\n}\n\nfragment UserNotesItemFragment on UserNote {\n  id\n  body\n  createdAt\n  addedByUser {\n    id\n    ...ProfileAvatarWithDetailsFragment\n  }\n}\n\nfragment useMemberGroupTagsList_OrganizationMembershipFragment on OrganizationMembership {\n  id\n  groupMemberships(groupKinds: [custom]) {\n    edges {\n      node {\n        id\n        productId\n        memberGroup {\n          id\n          parentMemberGroupId\n          visibility\n          ...MemberGroupTagFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2d5b4b984b105c40b447411e83ce478";

export default node;
